import type { JSX } from "preact";
import rawCloseSvg from "../assets/images/close-icon.svg";

export interface CloseIconProps {
  className?: string;
}

export function CloseIcon({ className }: CloseIconProps): JSX.Element {
  return (
    <span
      aria-hidden="true"
      className={className}
      // eslint-disable-next-line react/no-danger -- inlined bundled asset, no user input
      dangerouslySetInnerHTML={{ __html: rawCloseSvg }}
      style={{ display: "block", lineHeight: 0 }}
    />
  );
}
